export default __webpack_public_path__ + "static/media/risk-accept-circle.7f9a16f9.svg";